import React, { useRef, useEffect, useState } from 'react';
import { Container, CardBody, Card } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useReactToPrint } from 'react-to-print';
import { PreviewHTML } from 'vivace-fluent-motion';
import RelatorioApi from '../../../relatorio.api';
import * as commonActions from '@common/common.action';
import Impressao from './Impressao';
import IntlMessage from "../../../../../helpers/intlMessage";

function Relatorio({ showModalImprimir, setShowModalImprimir }) {
  const componentRef = useRef();
  const dispatch = useDispatch();

  const dadosGeraisHospital = useSelector(
    state => state.commonReducer.dadosGeraisHospital
  );

  const laudoSelecionado = useSelector(
    state => state.relatorio.laudoSelecionado
  );

  const [notificacoes, setNotificacoes] = useState([]);
  const [previewHTML, setPreviewHTML] = useState(false);

  useEffect(() => {
    if (showModalImprimir) {
      gerarRelatorio(laudoSelecionado.laudo);
    }
  }, [showModalImprimir]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: dadosGeraisHospital.razaosoc
  });

  const gerarRelatorio = laudoId => {
    dispatch(commonActions.showFadeCarregando(true));

    RelatorioApi.get(laudoId).then(resp => {
      dispatch(commonActions.showFadeCarregando(false));

      if (!resp.length) {
        const message = <IntlMessage id = "dashboards.reports.examNoNotification"/>
        dispatch(commonActions.showAlerta('alerta', message, 3000));
        setShowModalImprimir(false);
        return;
      }
      setNotificacoes(resp);
      setPreviewHTML(true);
    });
  };

  const ComponentHTML = ({ id }) => {
    return (
      <div className='mv-visualizador-html'>
        <Card id={id}>
          <CardBody>
            <Container fluid>
              <div ref={componentRef}>
                <Impressao lista={notificacoes} />
              </div>
            </Container>
          </CardBody>
        </Card>
      </div>
    );
  };

  return (
    <div>
      <PreviewHTML
        messageTitle = {<IntlMessage id = "dashboards.reports.printPreview"/>} 
        printLabel = {<IntlMessage id = "dashboards.reports.printOut"/>}
        visible={previewHTML}
        id='uniqueID'
        component={<ComponentHTML id='uniqueID' />}
        onOpened={e => {
          setPreviewHTML(e);
          setShowModalImprimir(e);
        }}
        onPrint={handlePrint}
      />
    </div>
  );
}

export default Relatorio;



// WEBPACK FOOTER //
// ./src/pages/relatorio/LaudoCritico/Relatorios/Notificacao/index.js